import SearchPage from "../components/searchpage";
export default SearchPage;
